import { Map, List, fromJS } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import axios from 'axios';

import { apiUrl } from 'libs/commonVar';
import * as shareLib from 'libs/shareLib';
import * as loginLib from 'libs/loginLib';

// action types
const INITIAL_STORE = 'login/INITIAL_STORE';
const GET_CHECKLOGIN = 'login/GET_CHECKLOGIN';
const POST_LOGIN = 'login/POST_LOGIN';
const SET_INITIAL = 'login/SET_INITIAL';
const INIT_LOGINRESULT = 'login/INIT_LOGINRESULT';
const CHANGE_INPUT = 'login/CHANGE_INPUT';
const ACTIVE_RECAPTCHA = 'login/ACTIVE_RECAPTCHA';
const VIEW_NOACTIVE = 'login/VIEW_NOACTIVE';
const CHANGE_SERVICE = 'login/CHANGE_SERVICE';

// action creator
export const initialStore = createAction(INITIAL_STORE);
export const getCheckLogin = createAction(GET_CHECKLOGIN, loginLib.getCheckLoginAPI);
export const postLogin = createAction(POST_LOGIN, loginLib.postLoginAPI);
export const postLoginGS = createAction(POST_LOGIN, loginLib.postLoginGSAPI);
export const setInitial = createAction(SET_INITIAL);
export const initLoginResult = createAction(INIT_LOGINRESULT);
export const changeInput = createAction(CHANGE_INPUT);
export const activeRecaptcha = createAction(ACTIVE_RECAPTCHA);
export const viewNoActive = createAction(VIEW_NOACTIVE);
export const changeService = createAction(CHANGE_SERVICE, shareLib.changeShareService);

const initialState = Map({
  login: Map({
    loginResult: 0,
    loginMessage: '',
    userData: null,
    serviceNo: null
  }),
  visible: Map({
    captcha: false,
    noActive: false
  }),
  form: Map({
    userEmail: '',
    userPasswd: '',
    isCaptcha: false
  })
});

export default handleActions(
  {
    // store 초기화
    [INITIAL_STORE]: (state, action) => {
      return initialState;
    },
    ...pender({
      // 로그인 요청은 GET이 아닌 POST로 해야 보안상 안전함(GET은 서버에 로그에 비밀번호가 default로 찍힘)
      type: POST_LOGIN,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;

        return state
          .setIn(['login', 'sessionTimeout'], list.sessionTimeout)
          .setIn(['login', 'loginResult'], list.loginResult)
          .setIn(['login', 'loginMessage'], list.loginMessage || '')
          .setIn(['login', 'userData'], list.userData)
          .setIn(['login', 'serviceNo'], list.serviceNo)
          .setIn(['login', 'originalServiceNo'], list.originalServiceNo);
      },
      onFailure: (state, action) => {
        console.log('Unable to connect to Server');

        return state.set(
          'login',
          Map({
            loginResult: 2,
            loginMessage: 'Unable to connect to Server',
            userData: null,
            serviceNo: null
          })
        );
      }
      // 함수가 생략됐을때 기본 값으론 (state, action) => state 가 설정됩니다 (state 를 그대로 반환한다는 것이죠)
    }),
    ...pender({
      type: GET_CHECKLOGIN,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;

        return state
          .setIn(['login', 'sessionTimeout'], list.sessionTimeout)
          .setIn(['login', 'userData'], list.userData)
          .setIn(['login', 'serviceNo'], list.serviceNo);
      },
      onFailure: (state, action) => {
        // 로그인 체크 실패
        console.log('Fail Login');

        return state.set('login', initialState.get('login'));
      }
    }),
    ...pender({
      // 로그인 요청은 GET이 아닌 POST로 해야 보안상 안전함(GET은 서버에 로그에 비밀번호가 default로 찍힘)
      type: CHANGE_SERVICE,
      onSuccess: (state, action) => {
        const { list, error } = action.payload.data;

        if (list) {
          return state
            .setIn(['login', 'loginResult'], list.loginResult)
            .setIn(['login', 'loginMessage'], 'Login Success (change service)')
            .setIn(['login', 'userData'], list.userData)
            .setIn(['login', 'serviceNo'], list.serviceNo)
            .setIn(['login', 'originalServiceNo'], list.originalServiceNo);
        } else if (error) {
          // 'No Allow Accesss Ip'
          return state.setIn(['login', 'loginResult'], 3);
        }
      },
      onFailure: (state, action) => {
        console.log('CHANGE_SERVICE Error');

        return state;
      }
      // 함수가 생략됐을때 기본 값으론 (state, action) => state 가 설정됩니다 (state 를 그대로 반환한다는 것이죠)
    }),
    // 로그인 데이터 초기화
    [SET_INITIAL]: (state, action) => {
      return state.set('login', initialState.get('login')).set('visible', initialState.get('visible'));
    },
    // 실패 메시지 지움
    [INIT_LOGINRESULT]: (state, action) => {
      return state.setIn(['login', 'loginResult'], 0);
    },
    [CHANGE_INPUT]: (state, action) => {
      const { name, value } = action.payload;
      return state.setIn(['form', name], value);
    },
    [ACTIVE_RECAPTCHA]: (state, action) => {
      return state.setIn(['visible', 'captcha'], true);
    },
    // 모달
    [VIEW_NOACTIVE]: (state, action) => {
      const type = action.payload;
      return state.setIn(['visible', 'noActive'], type);
    }
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/script/modules/login.js